<template>
  <div ref="map" />
</template>

<script>
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// == Source: https://github.com/Leaflet/Leaflet/issues/4968#issuecomment-483402699
// (Fix not showing Leaflet icons)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});
// ==

const MAP_PROVIDER_URL = `${process.env.VUE_APP_MAPS_URL}/tile/{z}/{x}/{y}.png`;
const MAP_PROVIDER_ATTRIBUTION =
  '&copy; autorzy <a href="https://www.openstreetmap.org/">OpenStreetMap</a>, <a href="https://creativecommons.org/licenses/by-sa/2.0/deed.pl">CC-BY-SA</a>';

export default {
  name: "geo-map",

  props: {
    view: Array,

    zoom: {
      type: Number,
      default: 13
    },

    maxZoom: {
      type: Number,
      default: 18
    },

    location: Object
  },

  data() {
    return {
      map: null,
      marker: null,
      zoomControl: null,
      options: {
        zoomControl: false,
        scrollWheelZoom: false,
        dragging: false,
        doubleClickZoom: false
      }
    };
  },

  mounted() {
    this.initMap();
    this.renderMap();
  },

  methods: {
    initMap() {
      this.map = L.map(this.$refs.map, this.options).setView(
        this.location.point,
        this.zoom
      );

      this.zoomControl = L.control.zoom();

      this.marker = L.marker(this.location.point).addTo(this.map);

      if (Element.prototype.requestFullscreen) {
        this.map.addEventListener("click", () =>
          this.$refs.map.requestFullscreen()
        );

        document.addEventListener(
          "fullscreenchange",
          this.handleFullscreenChange
        );

        L.DomUtil.addClass(this.map._container, "minimized");
      } else {
        this.enableControl();
      }
    },

    handleFullscreenChange() {
      if (document.fullscreenElement) {
        this.enableControl();
      } else {
        this.disableControl();
      }
    },

    enableControl() {
      L.DomUtil.removeClass(this.map._container, "minimized");
      this.marker.bindPopup(
        `<b>${this.location.name}</b><br />${this.location.desc}`
      );
      this.map.dragging.enable();
      this.map.scrollWheelZoom.enable();
      this.map.doubleClickZoom.enable();
      this.map.addControl(this.zoomControl);
    },

    disableControl() {
      L.DomUtil.addClass(this.map._container, "minimized");
      this.marker.unbindPopup();
      this.map.dragging.disable();
      this.map.scrollWheelZoom.disable();
      this.map.doubleClickZoom.disable();
      this.map.removeControl(this.zoomControl);
      this.map.setView(this.location.point, this.zoom);
    },

    renderMap() {
      L.tileLayer(MAP_PROVIDER_URL, {
        attribution: MAP_PROVIDER_ATTRIBUTION,
        maxZoom: this.maxZoom,
        noWrap: true,
        bounds: [[-90, -180], [90, 180]]
      }).addTo(this.map);
    }
  },

  watch: {
    location() {
      this.marker.remove();
      this.marker = L.marker(this.location.point).addTo(this.map);
      this.map.setView(this.location.point, this.zoom);
    }
  }
};
</script>

<!-- 
    Disclaimer: "scoped" is not allowed here anymore because
      the content of root div is dynamically generated
      and it doesn't have information about generated data-* attribute
      associated with scoped CSS.
-->
<style lang="scss">
.leaflet-container.minimized {
  cursor: pointer;
}
</style>
